import { IDatabaseLineItem } from "../../types";

interface ModalHeaderProps {
    lineItem: IDatabaseLineItem;
    onDismiss: () => void;
}

export const ModalHeader = ({ lineItem, onDismiss }: ModalHeaderProps) => (
    <div className="px-6 py-4 border-b flex items-start justify-between">
        <div>
            <h2 className="text-lg font-semibold text-stone-900">Xactimate Mapping Sync</h2>
            <p className="text-sm text-stone-500 mt-0.5">
                Review mappings for{" "}
                <span className="font-medium text-stone-700">
                    {lineItem.originalLineItem || lineItem.id}
                </span>
            </p>
        </div>
        <button
            className="text-stone-400 hover:text-stone-600 text-xl leading-none"
            onClick={onDismiss}
            aria-label="Close"
        >
            ×
        </button>
    </div>
);
